<template>
  <HomeView />
</template>

<script>
import HomeView from "./views/Home.vue";

export default {
  name: 'App',
  components: {
    HomeView
  }
}
</script>

<style>
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  a{
    text-decoration: none;
  }

  body, html {
    margin: 0;
    padding: 0;
    scroll-behavior: smooth;
  }

  body {
    /* background-color: #16010E; */
    background: linear-gradient(270deg, #16010E, rgb(73, 2, 46));
    /* background: linear-gradient(270deg, #49022E, black); */
    background-size: 400% 400%;
    animation: gradientAnimation 7s ease infinite;
  }

  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: rgb(165, 165, 165);
  }

  @keyframes gradientAnimation {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }
</style>
